import { useCallback, useEffect, useState } from 'react';

import { hashFor, tabFromHash, type Tab } from './router';

/** 订阅地址栏。切页写 hash，**所以手机的返回键是好使的**。 */
export function useRouter() {
  const [tab, setTab] = useState<Tab>(() => tabFromHash(location.hash));

  useEffect(() => {
    const onHash = () => setTab(tabFromHash(location.hash));
    // 首次进来时地址栏可能是空的，补一个规范的 hash，让返回栈从这里开始
    if (!location.hash) history.replaceState(null, '', hashFor(tabFromHash('')));
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  const go = useCallback((next: Tab) => {
    if (next === tabFromHash(location.hash)) return;
    location.hash = hashFor(next);
  }, []);

  return { tab, go };
}
